export const BacklogContract  = {
    
    async backlog_storage(date) {
        date

        throw new Error("backlog_backlog_storage not implemented");
    },

    async backlog_fulfillment(date) {
        date

        throw new Error("backlog_backlog_fulfillment not implemented");
    },

    async backlog_show_ff_details(client_name, cod_type, ff_type) {
        client_name;
        cod_type;
        ff_type;
        
        throw new Error("backlog_show_ff_details not implemented");
    }
}